import { render, staticRenderFns } from "./ChatPersonStatusChart.vue?vue&type=template&id=0c0f62d0"
import script from "./ChatPersonStatusChart.vue?vue&type=script&lang=js"
export * from "./ChatPersonStatusChart.vue?vue&type=script&lang=js"
import style0 from "./ChatPersonStatusChart.vue?vue&type=style&index=0&id=0c0f62d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports